module.exports = __webpack_public_path__ + "media/images/flags/4x3/mne-dd4c02968aaefdeaa0a6fb3c97a0fa2e.svg";